import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import SocialProfilesComponent from '../components/social-profiles/social-profiles.component';
import storePersist from '../../../../../redux/storePersist';
import PageLoader from '../../../../../components/PageLoader';

const SocialProfileContainer = ({ onSubmit, cardDetailInfo }: any) => {
  const librariesItems = storePersist?.get("library")?.current;
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedSocialProfiles, setSelectedSocialProfiles] = useState<any>([])

  // const fetchSocialProfileQueryById= ()=>{
  //   dispatch(socialProfiles.query({
  //     url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles/query`,
  //     entity:'socialProfiles',
  //     jsonData:{
  //     Records: [
  //       {
  //         Id: parmas?.id
  //       }
  //     ]
  //   }})).then(()=>{
  //     setIsQuery(true)
  //   })
  // }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedSocialProfiles({ ...selectedSocialProfiles, [field]: event })
  }

  useEffect(
    () => {

      if (cardDetailInfo) {
        setSelectedSocialProfiles(cardDetailInfo)
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    },
    []
  )



  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    onSubmit(selectedSocialProfiles)
  }



  return (
    <>

      {isLoading ? <PageLoader /> :
        <SocialProfilesComponent
          handleInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          selectedSocialProfiles={selectedSocialProfiles}
          socialProfileType={librariesItems?.SocialProfileType}
        />
      }
    </>
  )

}

export default SocialProfileContainer;